import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icons'

const ParkingPaymentError = ({ setStage, PAYMENT_STAGES }) => {
  const { t } = useTranslation(['parking'])
  return (
    <React.Fragment>
      <div className="parking-info__section error center">
        <Icon
          icon="cross"
          viewBox="0 0 20 20"
          styles={{ width: '40px', height: '40px', color: 'red', margin: '15px 0' }}
          svgProps={{ fill: '#CE2C21' }}
        />
        <div className="parking-info__section-title">{t('parking:paymentError.title')}</div>
        <div>{t('parking:paymentError.description')}</div>
      </div>
      <button
        onClick={() => setStage(PAYMENT_STAGES.PAYMENT)}
        className="button is-black"
        style={{ marginTop: '20px' }}
      >
        {t('parking:paymentError.retry')}
      </button>
    </React.Fragment>
  )
}

ParkingPaymentError.propTypes = {
  setStage: PropTypes.func,
  PAYMENT_STAGES: PropTypes.object,
}

export default ParkingPaymentError
